import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { useConstructionExtensions } from "@/hooks";
import { ExtensionType } from "@/models/constructionExtensions";
import { RootState } from "@/reducers/types";
import { KeepOutArea, Machine } from "@/sx-layout/components/plotmap/models";
import { useTerm } from "@/sx-layout/hooks";
import { getCurrentTimeInMinutes, timeStringToMinutes } from "@/sx-layout/utils";

type Props = {
  id: string;
  area: KeepOutArea;
  machine?: Machine;
  onClick?: () => void;
  style: React.CSSProperties;
};

export const KeepOutAreaObject: FC<Props> = ({ area, machine, ...props }) => {
  const layoutDate = useSelector<RootState, Date>((state) => state.plotmap.layoutDate);
  const { isToday } = useTerm(layoutDate);
  const { extension: objectTransparentExtension } = useConstructionExtensions(ExtensionType.PLOTMAP_OBJECT_TRANSPARENT);
  const isOutsideUseHours = useMemo(() => {
    if (!isToday || !objectTransparentExtension) return false;

    const now = getCurrentTimeInMinutes();
    const start = timeStringToMinutes(machine?.use_start_hour ?? area.use_start_hour);
    const end = timeStringToMinutes(machine?.use_end_hour ?? area.use_end_hour);

    return now < start || end < now;
  }, [
    objectTransparentExtension,
    isToday,
    area.use_start_hour,
    area.use_end_hour,
    machine?.use_start_hour,
    machine?.use_end_hour,
  ]);

  return (
    <div
      {...props}
      className="area-item relative w-full h-full"
      style={{ ...props.style, opacity: isOutsideUseHours ? 0.1 : 0.3 }}
    >
      <div id={`area-moveable-${area.keepout_area_id}`} className="relative h-full" />
    </div>
  );
};
